import { CourseProgressData, CourseProgressVars } from '../gql-types';
import React, { useState } from 'react';

import AuthService from '../../shared/services/AuthService';
import CourseProgress from '../models/CourseProgress';
import CourseProgressBar from './CourseProgressBar';
import CourseStatus from '../models/CourseStatus';
import GraphQL from '../gql';
import Pathway from '../models/Pathway';
import { isNull } from 'lodash';
import { useQuery } from '@apollo/client';

interface CourseProgressBarContainerProps {
  pathway: Pathway;
  visible: boolean;
  onStatusLoad: (pathkey: string, status: CourseStatus) => void;
}

const CourseProgressBarContainer = (props: CourseProgressBarContainerProps) => {
  const [courseProgress, setCourseProgress] = useState<CourseProgress>(null);

  const { loading, error, data } = useQuery<
    CourseProgressData,
    CourseProgressVars
  >(GraphQL.Query.COURSE_PROGRESS, {
    variables: {
      type: props.pathway.type,
      userkey: AuthService.Userkey,
      pathkey: props.pathway.pathkey
    },
    fetchPolicy: 'network-only',
    skip:
      props.pathway.wizardpath ||
      !isNull(courseProgress) ||
      props.visible !== true
  });

  if (data) {
    props.onStatusLoad(props.pathway.pathkey, data.courseProgress.status);
    if (isNull(courseProgress)) {
      setCourseProgress(data.courseProgress);
    }
  }

  return (
    <CourseProgressBar
      loading={loading}
      error={error}
      progress={courseProgress}
    />
  );
};

export default CourseProgressBarContainer;
